import { useAuth } from 'context/AuthContext';
import styles from './ReadOnlyGuard.module.css';

/**
 * Deshabilita visualmente acciones de escritura cuando isReadOnly=true.
 * Úsalo para envolver botones de crear/editar/eliminar.
 *
 * Uso:
 *   <ReadOnlyGuard>
 *     <button onClick={...}>Crear asamblea</button>
 *   </ReadOnlyGuard>
 */
export function ReadOnlyGuard({ children }) {
  const { isReadOnly } = useAuth();
  if (isReadOnly) return null;
  return children;
}

/**
 * Banner inline para secciones con acciones deshabilitadas.
 */
export function ReadOnlyBanner() {
  const { isReadOnly } = useAuth();
  if (!isReadOnly) return null;
  return (
    <div className={styles.banner}>
      <i className={`fas fa-lock ${styles.candado}`} />
      <span>
        <strong>Modo solo lectura.</strong> Puedes ver la información pero no puedes
        crear, editar ni eliminar datos. Una asamblea que ya estaba <strong>en curso</strong> sí
        se puede terminar. Renueva tu membresía para recuperar el acceso completo.
      </span>
    </div>
  );
}